import { render, staticRenderFns } from "./MediaHandler.vue?vue&type=template&id=13316c7a&scoped=true&"
import script from "./MediaHandler.vue?vue&type=script&lang=js&"
export * from "./MediaHandler.vue?vue&type=script&lang=js&"
import style0 from "./MediaHandler.vue?vue&type=style&index=0&id=13316c7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13316c7a",
  null
  
)

export default component.exports